export default {
  en: {
    or: "or",
    login: "Sign in ",
    logout: "Sign out",
    login_to_account: "Login",
    already_have_an_account: "Already have an account?",
    signup: "Sign up",
    google_login: "Sign in With Google",
    google_signup: "Sign up With Google",
    facebook_login: "Sign in With Facebook",
    facebook_signup: "Sign up With Facebook",
    first_name: "First name",
    last_name: "Last name",
    email: "Email address",
    mobile_number: "Mobile number",
    email_or_mobile: "Email address or mobile number",
    password: "Password",
    password_repeat: "Repeat password",
    reset_password: "Reset password",
    change_password: "Change Password",
    choose_password: "Choose Password",
    new_password: "New password",
    repeat_new_password: "Repeat new password",
    reset_password_desc:
      "Enter your Email address or phone number in order to recover your password.",
    yektanet_name: "Yektanet",
    najva_name: "Najva",
    triboon_name: "Triboon",
    pajva_name: "Pajva",
    fahva_name: "Fahva",
    bordboard_name: "BordBoard",
    jaryan_name: "Jaryan",
    adivery_name: "Adivery",
    novinhub_name: "Novinhub",
    chavosh_name: "Chavosh",
    lead_name: "Lead",
    rubika_name: "Rubika",
    sanjab_name: "Sanjab",
    divar_ads_name: "Divar Ads",
    yektanet_slogan: "Online Advertising Platform",
    najva_slogan: "Retention Marketing Service",
    triboon_slogan: "Reportage Ad Service",
    pajva_slogan: "The sponsorship platform in visual and audio media.",
    fahva_slogan: "Content creation platform",
    bordboard_slogan: "Outdoor Advertising Service",
    jaryan_slogan: "Social Network Advertising Platform",
    adivery_slogan: "Mobile Advertising Platform",
    novinhub_slogan: "Social Media Smart Assistant",
    chavosh_slogan: "- - -",
    rubika_slogan: "Rubika Panel",
    divar_ads_slogan: "Divar Ads Panel",
    lead_slogan: "Business Boost Platform",
    service_promotion_slogan: {
      long: "Manage all services in one account.",
      short: "All in one.",
    },
    search_account: "Search account",
    pls_choose_on_of_following: "Please choose one of the following methods:",
    continue: "Continue",
    verification_code: "Code",
    send_verification_code: "Send code",
    repeat_sending_verification_code: "Resend code",
    repeate_recieve_verification_code: "Request code again: ",
    verification_code_send: "Verification code was sent to your mobile number.",
    verification_code_is_correct: "Verification code is correct.",
    pls_enter_your_new_password: "Please enter your new password.",
    pls_choose_one_of_following_serivces:
      "please choose one of the following serivces.",
    create_account: "Create account",
    close: "Close",
    cut_image: "Crop image",
    edit_info: "Edit info",
    create_service: "Create service",
    no_edit_access: "You don't have edit access",
    create_new_service_with_new_url: "New service with new URL",
    create_new_service: "New service",
    website: "Website",
    telegram: "Telegram",
    instagram: "Instagram",
    android_app: "Android App",
    ios_app: "iOS App",
    adv: "Advertiser",
    pub: "Publisher",
    marketer: "Marketer",
    services: "Services",
    service_type: "Service type",
    service: "Service",
    service_title: "Service title",
    edit: "Edit",
    you_have_no_services: {
      long:
        "You need to create a new service in order to start using Yektanet, Najva, Triboon, Jaryan or NovinHub services.",
      short: "You have no services.",
    },
    yektanet_desc: {
      adv: {
        short: "I want to advertise my business.",
        long:
          "Choose advertiser if you want to advertise your business in Iran's most influencial websites.",
      },
      pub: {
        short: "I want to monetize my website.",
        long: "Choose publisher if you want to make revenue from your website.",
      },
      marketer: {
        short: "I want to be a marketer.",
        long: "- - -",
      },
    },
    najva_desc: {
      pub: {
        short: "I want to use the Najva's Retention Marketing service.",
        long:
          "By creating the Najva's service, you can send push notifications, emails, and SMS to your site users.",
      },
    },
    triboon_desc: {
      adv: {
        short: "I want to have reportage ads.",
        long:
          "Choose advertiser if you want to display your reportage ads in most ifluencial media.",
      },
      pub: {
        short: "I want to publish reportage ads.",
        long:
          "Choose publisher if you want to make revenue from publishing reportage ads in your websites.",
      },
    },
    pajva_desc: {
      adv: {
        short: "I want to have podcast ads.",
        long:
          "Choose advertiser if you want to display your podcast ads in most ifluencial media.",
      },
      pub: {
        short: "I want to publish podcast ads.",
        long:
          "Choose publisher if you want to make revenue from publishing podcast ads in your podcast.",
      },
    },
    fahva_desc: {
      adv: {
        short: "I want to have Content",
        long: "Choose business if you want to order content.",
      },
      pub: {
        short: "I want to create Content",
        long: "Choose author if you want to create content.",
      },
    },
    bordboard_desc: {
      adv: {
        short: "I want to place an order for outdoor advertising.",
        long:
          "If you want to place an order for outdoor advertising, register as a business.",
      },
    },
    jaryan_desc: {
      adv: {
        short: "I want to advertise my business in social media.",
        long:
          "Choose advertiser if you want to advertise in social media & colloborate with influencers.",
      },
      pub: {
        short: "I want to monetize my social media.",
        long:
          "Choose publisher if you want to make revenue from displaying ads in your social media.",
      },
    },
    adivery_desc: {
      pub: {
        short: "I want to monetize my app.",
        long: "You can make revenue by displaying ads in your app.",
      },
    },
    novinhub_desc: {
      pub: {
        short: "I want to monetize my app.",
        long: "You can make revenue by displaying ads in your app.",
      },
    },
    chavosh_desc: {
      adv: {
        name: "---",
        short: "---",
        long: "---",
      },
      pub: {
        name: "---",
        short: "---",
        long: "---",
      },
    },
    lead_desc: {
      cus: {
        name: "Customer",
        short: "I want to boost my business.",
        long:
          "Choose customer if you want to purchase leads to boost your business with.",
      },
      sup: {
        name: "Supplier",
        short: "I want to provide leads.",
        long: "Choose supplier if you are an advertiser who can provide leads.",
      },
    },
    choose_address: "Choose URL address",
    choose_service: "Choose service",
    choose_service_type: "Choose service type",
    create: "Create",
    address_title: "Address title",
    final_confirmation: "Confirm",
    choose: "Choose",
    chosen: "Already chosen",
    sample_formats: "Sample formats",
    created: "Already created",
    back: "Back",
    title: "Title",
    cancel: "Cancel",
    im_sure: "I'm sure",
    remove: "Remove",
    verified: "Verified",
    not_verified: "Not verified",
    register: "Register",
    social_accounts: "Social Accounts",
    management: "Management",
    mobile: "Mobile",
    user_info: "User Info",
    khadamat: "Platforms",
    account: "Account",
    exit: "Sign out",
    privacy: "Privacy",
    termsOfService: "Terms of service",
    validation_message: {
      email_or_mobile_is_required:
        "Please enter your Email address or mobile number.",
      phone_is_required: "Please enter your mobile number.",
      firstName_is_required: "Please enter your first name.",
      lastName_is_required: "Please enter your last name.",
      email_is_required: "Please enter your Email address.",
      password_is_required: "Please enter your password.",
      password_repeat_is_required: "Please repeat your password.",
      addressType_is_required: "Please choose your URL address type.",
      address_is_required: "Please enter your URL address.",
      addressTitle_is_required: "Please choose a title for your address.",
      serviceType_is_required: "Please choose your service type.",
      service_is_required: "Please choose your service.",
      field_is_required: "This field is required.",
      phone: "Mobile Number must start with 00 and contain 8 to 15 numbers.",
      website: "Website URL is not valid.",
      telegram: "Telegram address is not valid.",
      instagram: "Instagram address is not valid.",
      android_app: "Android app address is not valid.",
      ios_app: "iOS app address is not valid.",
      code: "Code is not valid.",
      email: "Email is not valid.",
      password: "Password must be at least 6 charachters or digits.",
      password_repeat: "Repeated password does not match the new password.",
      address: "Address is not valid.",
    },
    verify: "Verify",
    address: "Address",
    email_management: "Email Management",
    mobile_management: "Mobile Management",
    account_management: "Account Management",
    address_type: "Address Type",
    create_new_address: "Create New Address",
  },
  fa: {
    or: "یا",
    login: "ورود",
    logout: "خروج",
    login_to_account: "ورود به حساب کاربری",
    already_have_an_account: "قبلا ثبت‌نام کرده‌اید؟",
    signup: "ثبت‌نام",
    google_login: "ورود با گوگل",
    google_signup: "ثبت‌نام با گوگل",
    facebook_login: "ورود با فیسبوک",
    facebook_signup: "ثبت‌نام با فیسبوک",
    first_name: "نام",
    last_name: "نام خانوادگی",
    email: "ایمیل",
    mobile_number: "شماره موبایل",
    email_or_mobile: "ایمیل یا شماره موبایل",
    password: "گذرواژه",
    password_repeat: "تکرار گذرواژه",
    reset_password: "بازیابی گذرواژه",
    change_password: "تغییر گذرواژه",
    choose_password: "انتخاب گذرواژه",
    new_password: "گذرواژه جدید",
    repeat_new_password: "تکرار گذرواژه جدید",
    reset_password_desc:
      "برای دریافت گذرواژه جدید، ایمیل یا شماره موبایل خود را وارد نمایید. ",
    yektanet_name: "یکتانت",
    najva_name: "نجوا",
    triboon_name: "تریبون",
    pajva_name: "پژوا",
    fahva_name: "فحوا",
    bordboard_name: "بردبورد",
    jaryan_name: "جریان",
    adivery_name: "ادیوری",
    novinhub_name: "نوین‌هاب",
    chavosh_name: "چاوش",
    rubika_name: "روبیکا",
    lead_name: "سرنخ",
    sanjab_name: "سنجاب",
    divar_ads_name: "دیوار ادز",
    yektanet_slogan: "پلتفرم تبلیغات آنلاین",
    najva_slogan: "سرویس ریتنشن مارکتینگ",
    triboon_slogan: "سرویس انتشار رپورتاژ آگهی",
    pajva_slogan: "پلتفرم اسپانسرشیپ در رسانه‌های دیداری و شنیداری",
    fahva_slogan: "پلتفرم تولید محتوا",
    bordboard_slogan: "سرویس ارائه تبلیغات محیطی",
    jaryan_slogan: "پلتفرم تبلیغات شبکه‌های اجتماعی",
    sanjab_slogan: "پلتفرم تحلیل تخصصی اینستاگرام",
    adivery_slogan: "درآمدزایی از تبلیغات اپلیکیشن",
    novinhub_slogan: "دستیار هوشمند شبکه‌های اجتماعی",
    chavosh_slogan: "پلتفرم همكاری در فروش",
    lead_slogan: "پلتفرم تقویت کسب‌وکار",
    rubika_slogan: "ادز نمایش در بزرگترین شبکه اجتماعی ایرانی",
    divar_ads_slogan: "تبلیغات هدفمند در پلتفرم دیوار با ۴۰ میلیون کاربر فعال",
    service_promotion_slogan: {
      long:
        "شما می‌توانید از یک حساب واحد برای مدیریت و ورود به همه خدمات یکتانت، نجوا، تریبون، جریان، ادیوری و چاوش و پژوا استفاده کنید.",
      short: "همه خدمات با یک حساب",
    },
    search_account: "جستجوی حساب",
    pls_choose_on_of_following: "لطفا یکی از روش‌های زیر را انتخاب کنید.",
    continue: "ادامه",
    verification_code: "کد تایید",
    send_verification_code: "ارسال کد تایید",
    repeat_sending_verification_code: "ارسال مجدد کد تایید",
    repeate_recieve_verification_code: "دریافت مجدد کد تایید",
    verification_code_send: "کد تایید به شماره موبایل شما ارسال شد.",
    verification_code_is_correct: "کد تایید به درستی وارد شد.",
    pls_enter_your_new_password: "لطفا گذرواژه‌ی جدید خود را وارد کنید.",
    pls_choose_one_of_following_serivces:
      "برای ادامه یکی از خدمات زیر را انتخاب کنید.",
    create_account: "ساخت حساب",
    close: "بستن",
    cut_image: "برش تصویر",
    edit_info: "ویرایش اطلاعات",
    create_service: "ساخت سرویس",
    no_edit_access: "شما دسترسی ویرایش ندارید",
    create_new_service_with_new_url: "سرویس با آدرس جدید",
    create_new_service: "سرویس جدید",
    website: "وبسایت",
    telegram: "تلگرام",
    instagram: "اینستاگرام",
    android_app: "اندروید",
    ios_app: "آی‌او‌اس",
    adv: "تبلیغ‌کننده",
    pub: "نمایش‌دهنده",
    marketer: "کارشناس فروش",
    services: "سرویس‌ها",
    service_type: "نوع سرویس",
    service: "سرویس",
    service_title: "عنوان آدرس",
    edit: "ویرایش",
    you_have_no_services: {
      long:
        "برای شروع یک سرویس ایجاد کنید. با ساخت سرویس می‌توانید از انواع خدمات یکتانت، نجوا، تریبون، جریان، ادیوری و چاوش و پژوا استفاده کنید.",
      short: "شما هیچ سرویسی ندارید.",
    },
    yektanet_desc: {
      adv: {
        name: "تبلیغ‌کننده",
        short: "می‌خواهم برای کسب‌ و کار خود تبلیغ کنم.",
        long:
          "اگر می‌خواهید تبلیغ خود را در وب‌سایت‌های معتبر کشور به نمایش بگذارید و به برندسازی و سئوی خود کمک کنید تبلیغ را انتخاب کنید.",
      },
      pub: {
        name: "نمایش‌دهنده",
        short: "می‌خواهم نمایش‌دهنده تبلیغات باشم.",
        long:
          "اگر می‌خواهید با انتشار تبلیغات در وب‌سایت خود کسب درآمد داشته باشید نمایش‌دهنده را انتخاب کنید.",
      },
      marketer: {
        name: "کارشناس فروش",
        short: "می‌خواهم کارشناس فروش باشم.",
        long: "",
      },
    },
    lead_desc: {
      cus: {
        name: "خریدار",
        short: "می‌خواهم کسب و کار خود را با گسترش دهم.",
        long:
          "اگر می‌خواهید از طریق خرید سرنخ افراد کسب و کار خود را گسترش دهید، خریدار را انتخاب کنید.",
      },
      sup: {
        name: "تامین‌کننده",
        short: "می‌خواهم تامین‌کننده سرنخ باشم.",
        long:
          "اگر تبلیغ‌کننده‌ای هستید که می‌توانید سرنخ دست‌اول تولید کنید، تامین‌کننده را انتخاب کنید.",
      },
    },
    najva_desc: {
      pub: {
        name: "نمایش‌دهنده",
        short: "می‌خواهم از سرویس ریتنشن مارکتینگ نجوا استفاده کنم.",
        long:
          "با ایجاد سرویس نجوا می‌توانید به کاربران سایت خود پوش نوتیفیکیشن، ایمیل و پیامک ارسال کنید.",
      },
    },
    triboon_desc: {
      adv: {
        name: "تبلیغ‌کننده",
        short: "می‌خواهم سفارش انتشار رپورتاژ بدهم.",
        long:
          "اگر می‌خواهید رپورتاژ خود را در وب‌سایت‌های معتبر کشور منتشر کنید و به برندسازی و سئوی خود کمک کنید سفارش رپورتاژ را انتخاب کنید.",
      },
      pub: {
        name: "نمایش‌دهنده",
        short: "می‌خواهم نمایش‌دهنده رپورتاژ باشم.",
        long:
          "اگر می‌خواهید با انتشار رپورتاژ در وب‌سایت خود کسب درآمد داشته باشید به عنوان نمایش‌دهنده ثبت‌نام کنید.",
      },
    },
    pajva_desc: {
      adv: {
        name: "کسب‌وکار",
        short: "می‌خواهم سفارش انتشار تبلیغات بدهم.",
        long:
          "اگر می‌خواهید تبلیغ خود را در رسانه‌های دیداری و شنیداری پر مخاطب منتشر کنید، به عنوان کسب‌وکار ثبت‌نام کنید.",
      },
      pub: {
        name: "میزبان",
        short: "می‌خواهم نمایش‌دهنده تبلیغات باشم.",
        long:
          "اگر می‌خواهید با انتشار تبلیغ در رسانه دیداری و شنیداری خود کسب درآمد داشته باشید به عنوان میزبان ثبت‌نام کنید.",
      },
    },
    fahva_desc: {
      adv: {
        name: "کسب‌وکار",
        short: "می‌خواهم سفارش تولید محتوا بدهم.",
        long:
          "اگر می‌خواهید سفارش تولید محتوا بدهید، به عنوان کسب‌وکار ثبت‌نام کنید.",
      },
      pub: {
        name: "نویسنده",
        short: "می‌خواهم نویسنده محتوا باشم.",
        long:
          "اگر می‌خواهید با تولید محتوا کسب درآمد داشته باشید به عنوان میزبان نویسنده کنید.",
      },
    },
    bordboard_desc: {
      adv: {
        name: "کسب‌وکار",
        short: "می‌خواهم سفارش تبلیغات محیطی بدهم.",
        long:
          "اگر می‌خواهید سفارش تبلیغات محیطی بدهید، به عنوان کسب‌وکار ثبت‌نام کنید.",
      },
    },
    jaryan_desc: {
      adv: {
        name: "تبلیغ‌کننده",
        short: "میخواهم برای کسب‌وکار خود تبلیغ‌ کنم.",
        long:
          "اگر می‌خواهید تبلیغ خود را در شبکه‌های اجتماعی منتشر کنید یا با اینفلوئنسرها همکاری کنید، یک حساب تبلیغ‌کننده جریان بسازید.",
      },
      pub: {
        name: "نمایش‌دهنده",
        short: "میخواهم از تبلیغات درآمد کسب کنم.",
        long:
          "اگر می‌خواهید با انتشار تبلیغ در پیج یا کانال خود کسب درآمد کنید، یک حساب نمایش‌دهنده جریان بسازید.",
      },
      discover: {
        name: "کاربر دیسکاور",
        short: "می‌خواهم اطلاعات پیج‌ها را مشاهده کنم.",
        long:
          "در صورتی که صاحب کسب و کار یا فعال در حوزه‌ی تبلیغات شبکه‌های اجتماعی هستید و می‌خواهید تصمیماتتان را با کمک داده بگیرید، اکانت کاربر دیسکاور جریان بسازید.",
      },
    },
    sanjab_desc: {
      discover: {
        name: "سنجاب",
        short: "می‌خواهم اطلاعات پیج‌ها را مشاهده کنم.",
        long:
          "در صورتی که صاحب کسب و کار یا فعال در حوزه‌ی تبلیغات شبکه‌های اجتماعی هستید و می‌خواهید تصمیماتتان را با کمک داده بگیرید، اکانت کاربر سنجاب بسازید.",
      },
    },
    adivery_desc: {
      pub: {
        name: "نمایش‌دهنده",
        short: "می‌خواهم با نمایش تبلیغات از اپلیکیشنم درآمدزایی کنم.",
        long:
          "با ایجاد سرویس نمایش‌دهنده‌ی ادیوری می‌توانید با نمایش تبلیغات در اپلیکیشن خود، درآمد کسب کنید.",
      },
    },
    novinhub_desc: {
      pub: {
        name: "نمایش‌دهنده",
        short: "می‌خواهم از سرویس ریتنشن مارکتینگ نجوا استفاده کنم.",
        long:
          "با ایجاد سرویس نجوا می‌توانید به کاربران سایت خود پوش نوتیفیکیشن، ایمیل و پیامک ارسال کنید.",
      },
    },
    chavosh_desc: {
      adv: {
        name: "فروشگاه",
        short: "می‌خواهم محصولاتم را بفروشم.",
        long:
          "اگر می خواهید محصولات و خدمات خود را در پلتفرم همکاری در فروش چاوش عرضه کنید، یک حساب فروشگاه بسازید.",
      },
      pub: {
        name: "ناشر (افیلیت)",
        short: "می‌خواهم از رسانه‌ام درآمدزایی کنم.",
        long:
          "اگر می‌خواهید از محتوا و مخاطبی که دارید درآمدزایی کنید، یک حساب ناشر (افیلیت) چاوش بسازید.",
      },
    },
    choose_address: "انتخاب آدرس",
    choose_service: "انتخاب سرویس",
    choose_service_type: "انتخاب نوع سرویس",
    create: "ساخت",
    address_title: "عنوان آدرس",
    package_name_title: "عنوان Package name",
    address_title_help:
      "عنوان آدرس، نامی است که برای آدرس خود انتخاب می‌کنید و در لیست سرویس‌های شما نمایش داده می‌شود. مثال: کانال تلگرام یکتانت",
    package_name_title_help:
      "عنوان پکیج‌نیم، نامی است که برای اپلیکیشن خود انتخاب می‌کنید و در لیست سرویس‌های شما نمایش داده می‌شود.",
    final_confirmation: "تایید نهایی",
    choose: "انتخاب",
    chosen: "انتخاب شده",
    sample_formats: "فرمت‌های نمونه آدرس",
    created: "ساخته شده",
    back: "بازگشت",
    title: "عنوان",
    cancel: "انصراف",
    im_sure: "مطمئن هستم",
    remove: "حذف",
    verified: "تایید شده",
    not_verified: "تایید نشده",
    register: "ثبت",
    social_accounts: "حساب گوگل",
    management: "مدیریت",
    mobile: "موبایل",
    user_info: "اطلاعات کاربری",
    khadamat: "خدمات",
    account: "حساب",
    exit: "خروج",
    privacy: "حریم خصوصی",
    termsOfService: "شرایط استفاده از خدمات",
    validation_message: {
      email_or_mobile_is_required:
        "لطفا ایمیل یا شماره موبایل خود را وارد کنید.",
      phone_is_required: "لطفا شماره موبایل خود را وارد کنید.",
      firstName_is_required: "لطفا نام خود را وارد کنید.",
      lastName_is_required: "لطفا نام خانوادگی خود را وارد کنید.",
      email_is_required: "لطفا ایمیل خود را وارد کنید.",
      password_is_required: "لطفا گذرواژه را وارد کنید.",
      password_repeat_is_required: "لطفا تکرار گذرواژه را وارد کنید.",
      addressType_is_required: "لطفا نوع آدرس را انتخاب کنید.",
      address_is_required: "لطفا آدرس را وارد نمایید.",
      addressTitle_is_required: "لطفا عنوان آدرس را وارد نمایید.",
      serviceType_is_required: "لطفا ‌‌‌نوع سرویس مورد نظر خود را انتخاب کنید.",
      service_is_required: "لطفا سرویس مورد نظر خود را انتخاب کنید.",
      field_is_required: "این فیلد الزامی است.",
      phone: "شماره تلفن همراه باید ۱۱ رقم بوده و با ۰۹ شروع شود.",
      website: "آدرس وبسایت وارد شده نامعتبر است.",
      telegram: "آدرس کانال تلگرام وارد شده نامعتبر است.",
      instagram: "آدرس پیج اینستاگرام وارد شده نامعتبر است.",
      android_app: "آدرس اپلیکیشن اندروید وارد شده نامعتبر است.",
      ios_app: "آدرس اپلیکیشن ای‌او‌اس وارد شده نامعتبر است.",
      code: "کد وارد شده معتبر نیست.",
      email: "ایمیل وارد شده نامعتبر است.",
      password: "گذرواژه باید حداقل ۶ حرف باشد.",
      password_repeat: "تکرار گذرواژه با اصل آن یکسان نیست.",
      address: "آدرس وارد شده صحیح نیست.",
    },
    verify: "تایید",
    address: "آدرس",
    package_name: "نام پکیج (Package name)",
    email_management: "مدیریت آدرس ایمیل",
    mobile_management: "مدیریت شماره موبایل",
    account_management: "مدیریت حساب",
    address_type: "نوع آدرس",
    create_new_address: "ساخت آدرس جدید",
  },
};
